/* Native product tabs. Paired with snippets/product-tabs.liquid + assets/product-tabs.css.
   The markup ships as a <details> accordion, so it is fully usable before this file runs
   (and if it never runs). Here we upgrade it to a tab bar on wider screens. */
(function () {
  "use strict";

  function init(root) {
    // Tells the snippet's watchdog that the behaviour script is in charge.
    root.setAttribute("data-egd-ready", "1");

    var list = root.querySelector(".egd-tabs__list");
    var buttons = Array.prototype.slice.call(root.querySelectorAll(".egd-tabs__tab"));
    var panels = Array.prototype.slice.call(root.querySelectorAll(".egd-tabs__panel"));
    if (!list || !buttons.length || buttons.length !== panels.length) return;

    var breakpoint = parseInt(root.getAttribute("data-egd-breakpoint"), 10) || 767;
    var tabbed = null;
    // The panel most recently asked for, by the user or by us. The <details> "toggle"
    // event is dispatched asynchronously, so this is what lets a late toggle know it
    // has been superseded by a newer selection.
    var current = null;
    var scrollAfterToggle = false;

    for (var i = 0; i < panels.length; i++) {
      if (panels[i].open) { current = panels[i]; break; }
    }

    function sync() {
      for (var j = 0; j < buttons.length; j++) {
        var on = panels[j].open;
        buttons[j].setAttribute("aria-selected", on ? "true" : "false");
        buttons[j].tabIndex = tabbed ? (on ? 0 : -1) : 0;
      }
    }

    // One panel at a time, in both modes (matches the previous app behaviour).
    function closeOthers(keep) {
      for (var k = 0; k < panels.length; k++) {
        if (panels[k] !== keep && panels[k].open) panels[k].open = false;
      }
    }

    function select(index, moveFocus) {
      if (index < 0 || index >= panels.length) return;
      current = panels[index];
      scrollAfterToggle = false;
      closeOthers(current);
      if (!current.open) current.open = true;
      sync();
      if (moveFocus && tabbed) buttons[index].focus();
    }

    panels.forEach(function (panel) {
      var summary = panel.querySelector(".egd-tabs__summary");
      if (summary) {
        summary.addEventListener("click", function () {
          // The native toggle happens after this handler. Remember what was asked for,
          // and in accordion mode follow the panel once the one above it collapses.
          current = panel;
          scrollAfterToggle = !tabbed;
        });
      }
      panel.addEventListener("toggle", function () {
        var wantScroll = scrollAfterToggle;
        scrollAfterToggle = false;
        if (!panel.open) { sync(); return; }
        if (panel !== current) { panel.open = false; return; } // superseded by a later pick
        closeOthers(panel);
        if (wantScroll) panel.scrollIntoView({ block: "nearest", behavior: "smooth" });
        sync();
      });
    });

    buttons.forEach(function (button, index) {
      button.addEventListener("click", function () { select(index, false); });
      button.addEventListener("keydown", function (event) {
        var next = null;
        if (event.key === "ArrowRight") next = (index + 1) % buttons.length;
        else if (event.key === "ArrowLeft") next = (index - 1 + buttons.length) % buttons.length;
        else if (event.key === "Home") next = 0;
        else if (event.key === "End") next = buttons.length - 1;
        if (next === null) return;
        event.preventDefault();
        select(next, true);
      });
    });

    function apply() {
      var want = window.innerWidth >= breakpoint;
      if (want === tabbed) return;
      tabbed = want;
      root.classList.toggle("egd-tabs--is-tabbed", tabbed);

      if (tabbed) {
        list.hidden = false;
        list.setAttribute("role", "tablist");
        buttons.forEach(function (b) { b.setAttribute("role", "tab"); });
        panels.forEach(function (p) {
          p.setAttribute("role", "tabpanel");
          var by = p.getAttribute("data-egd-labelledby");
          if (by) p.setAttribute("aria-labelledby", by);
        });
        // A tab view always has exactly one panel showing.
        var idx = current ? panels.indexOf(current) : -1;
        select(idx === -1 ? 0 : idx, false);
      } else {
        list.hidden = true;
        list.removeAttribute("role");
        buttons.forEach(function (b) { b.removeAttribute("role"); });
        panels.forEach(function (p) {
          p.removeAttribute("role");
          p.removeAttribute("aria-labelledby");
        });
      }
      sync();
    }

    // Deep links such as #tabs-compatibility keep working.
    function openFromHash(scroll) {
      var hash = window.location.hash.replace(/^#/, "");
      if (!hash) return;
      for (var m = 0; m < panels.length; m++) {
        if (panels[m].getAttribute("data-egd-panel") === hash || panels[m].id === hash) {
          select(m, false);
          if (scroll) root.scrollIntoView({ behavior: "smooth", block: "start" });
          return;
        }
      }
    }

    // Things elsewhere on the page scroll to content that lives inside a tab: the Stamped
    // star badge scrolls to the reviews widget, and in-page links can target an id in a
    // panel. A closed <details> still reports geometry to scripts, so that scroll lands
    // far down the page on nothing. Open the owning panel first, in the capture phase,
    // before the other handler measures where to go.
    function revealTarget(target) {
      if (!target) return;
      for (var n = 0; n < panels.length; n++) {
        if (panels[n].contains(target)) {
          if (!panels[n].open) select(n, false);
          return;
        }
      }
    }
    document.addEventListener("click", function (event) {
      var origin = event.target && event.target.closest
        ? event.target.closest(".stamped-product-reviews-badge, .stamped-badge, a[href^='#']")
        : null;
      if (!origin || root.contains(origin)) return;
      var href = origin.getAttribute("href");
      var target = href && href.length > 1
        ? document.getElementById(href.slice(1))
        : root.querySelector("#stamped-main-widget");
      revealTarget(target);
    }, true);

    var resizeTimer;
    window.addEventListener("resize", function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(apply, 150);
    });
    window.addEventListener("hashchange", function () { openFromHash(true); });

    apply();
    openFromHash(false);
  }

  function boot() {
    var roots = document.querySelectorAll("[data-egd-tabs]");
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
